import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, OnInit } from '@angular/core';
import {DOCUMENT} from '@angular/common';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LoginRecords, LoginReq, LoginRes, AccessMenu, ResetPasswordReq, ResetPasswordRes, LoginConfirmationRes, LogoutRes, RecaptchaRes, resetPwdUserInfo, ForgotPasswordReq, ForgotPasswordRes, UpdatePasswordReq, UpdatePasswordRes, ResetUpdatePasswordReq, ResetUpdatePasswordRes } from '@entity/login';
import { NavigationLite, NavList } from '@entity/navigation';
import { UserRoles, archiveRefName } from '@entity/user-role';
import { NguAlertService } from '@app/shared';
import { DateHelperService } from '../services';
import { EncryptService } from './encrypt.service';
import { promise } from 'protractor';
import { Observable, Subject } from 'rxjs';
import { ConfirmationDialog } from '@app/library';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnInit {
  private _defaultUrls: string;
  private storeRoles: any;
  private _navListLite: NavigationLite;
  private _accessMenus: any;
  development = false;
  //_navMenuLists = new Observable<any>();
  //storeMenu = new Subject();
  _navMenuLists: any;
  whiteListRoutes = ['/transaction/displayEmailLog', '/transaction/displayEmailQueue'];

  /** Set your Page title */
  pageTitle: string;

  private userData: LoginRecords;
  private menuListData: AccessMenu;
  refreshTokenTimeout = true;
  // private jwtHelper: JwtHelper = new JwtHelper();

  /** Know whether the user is logged in */
  get isLoggedIn() {
    // console.log(" is logged in check in start auth.service.ts :: ", new Date());
    const isValid = !this.jwtHelper.isTokenExpired();
    // console.log(" is logged in check in start auth.service.ts :: isValid  token check :: " + isValid + " :: ", new Date());
    if (isValid) {
      this.refreshToken();
    }
    return isValid;
  }
  get isTokenExpired() {
    return this.jwtHelper.isTokenExpired();
  }
  /** get the URL so we can redirect after logging in */
  redirectUrl: string;
  errorMessageDuration = environment.errorDuration;

  constructor(
    private http: HttpClient,
    public router: Router,
    private enc: EncryptService,
    private jwtHelper: JwtHelperService,
    private alert: NguAlertService,
    private date: DateHelperService,
    //private pop: ConfirmationService,
    @Inject(DOCUMENT) document: any
  ) { }

  ngOnInit() {
    console.log(this.navLite);
    this.errorMessageDuration = this.errorMessageDuration ? this.errorMessageDuration : 1000
  }

  /** Get Host name */
  get hostName() {
    const data = document.location.href.split('/');
    return data.slice(0, 3).join('/');
  }

  getDomainName() {
    //"https://llwr.cyb.co.uk/login" or "https://archive.llwr.cyb.co.uk/login"
    //debugger;
    let isArchiveFlag = '';
    const data = document.location.href.split('/')[2];
    isArchiveFlag = data.split('.')[0]; //which is return 'archive' otherwise 'undefined'

    if (isArchiveFlag && isArchiveFlag.includes(archiveRefName.archive)) {
      //get all enquiry list
      isArchiveFlag = 'llwrarchive';
    } else {
      isArchiveFlag = 'llwr';
    }
    //isArchiveFlag = 'llwrarchive';
    return isArchiveFlag;
  }

  getForumUrl() {
    return this.hostName + '/llwrForum/public/auth/' + btoa(this.loginData.AssociatedId);
  }

  /** get token from localhost */
  get token() {
    return sessionStorage.getItem('token');
  }
  /** get token from localhost */
  get accessMenuJson() {
    return sessionStorage.getItem('accessMenuJson');
  }

  /** get the Navigation list as a lite version with { id: title } */
  // get navLite() {
  //   if (!this._navListLite) {
  //     const data = new NavigationLite();
  //     this.navListData.forEach(elem => {
  //       data[elem.url] = {
  //         id: elem.id
  //       };
  //       elem.child.forEach(childElem => {
  //         data[childElem.url] = {
  //           id: childElem.id
  //         };
  //         data[childElem.url]['perms'] = {};
  //         childElem.perms.forEach(element => {
  //           data[childElem.url].perms[element.name] = element.id;
  //         });
  //       });
  //     });
  //     this._navListLite = data;
  //   }
  //   return this._navListLite;
  // }
  get navLite() {
    if (!this._navListLite) {
      const data = new NavigationLite();
      let accessMenus: any[] = [];
      if (this.AcessMenuList == null || this.AcessMenuList == undefined) {
        this.router.navigate["/login"];
      }
      else {
        this.AcessMenuList.newAccessMenu.forEach(elem => {
          //console.log(" elem : ",elem);
          data[elem.url] = {
            id: elem.id
          };
          accessMenus[elem.id] = [];
          elem.child.forEach(childElem => {
            data[childElem.url] = {
              id: childElem.id
            };
            accessMenus[childElem.id] = [];
            data[childElem.url]['perms'] = {};
            if (childElem.perms) {
              childElem.perms.forEach(element => {
                data[childElem.url].perms[element.name] = element.id;
                if (element.permission) {
                  accessMenus[childElem.id].push(element.id);
                }
              });
            }
            if (accessMenus[childElem.id].length === 0) {
              accessMenus[childElem.id] = null;
            }
          });
          /* let a = data;
          let am = accessMenus;
          console.log("data :: ",JSON.stringify(a));
          console.log(" accessMenus : ",JSON.stringify(am)); */
        });
        this._navListLite = data;
        this._accessMenus = accessMenus;
      }
    }
    return { '_navListLite': this._navListLite, '_accessMenus': this._accessMenus };
  }

  /** Used to verify the user credentials */
  login(body: LoginReq) {
    return new Promise(resolve => {
      // console.log(body.password);
      let bod;
      // if (document.location.href.split('/')[2] !== 'llwr.cyb.co.uk') {
      const pass = this.enc.encrypt(body.password, true);
      const oldpass = this.enc.encryptPwd(body.password);
      bod = {
        username: body.username,
        password: pass,
        oldpassword: oldpass,
        loginFlag: body.loginFlag
      };
      this.http.post<LoginRes>('authenticate', bod).subscribe(
        (res:any) => {
          //debugger;
          if (res.reset) {
            localStorage.setItem("resetFlag", "true");
            this.loginData = res.token;
            this.router.navigate(['/resetpassword']);
          }
          else {
            this.loginData = res.token;
            if (res.loggedin){
              resolve('loginConfirmation');
              //window.location.reload();
            }
            else {
              this.AcessMenuList = res.accessMenuJson;
              if (!this.defaultUrl) {
                resolve('DefaultPage');
                return false;
              }
              resolve(this.defaultUrl);
            }
          }
        },
        (err: HttpErrorResponse) => {
          if (err.status === 401) {
            resolve(false);
            console.log(err);
          }
        }
      );
    });
  }

  loginConfirmation() {
    return this.http.post<LoginConfirmationRes>('forcelogout', null);
  }

  logoutApi() {
    return this.http.post<LogoutRes>('logout', null);
  }

  resetPassword(body: ResetPasswordReq) {
    return new Promise(resolve => {
      let data = {
        password: this.enc.encrypt(body.newPassword, true),
        old_password: this.enc.encryptPwd(body.oldPassword),
        old_password1: this.enc.encrypt(body.oldPassword, true),
        ref: this.loginData.UserId
      };
      this.http.post<ResetPasswordRes>('password/reset', data).subscribe(
        (res:any) => {

          var status = res.Status
          if (!res["data"].success)
            resolve(false);
          else
            this.router.navigate(['/login']);
        },
        (err: HttpErrorResponse) => {
          if (err.status === 401)
            console.log(err);
        }
      );
    });
  }

  resetUpdatePassword(body: ResetUpdatePasswordReq) {
    //debugger;
    return new Promise(resolve => {
      let data = {
        token: body.token,
      };
      this.http.post<ResetUpdatePasswordRes>('resetpassword', data).subscribe(
        (res:any) => {
          //debugger;
          var resp = res.Status;

          if (resp == "Failed" || resp == undefined) {
            resolve(false);
            sessionStorage.setItem('message', res.message);

            this.alert.open({
              //heading: err['data'].message,
              heading: res.message,
              // msg: 'System cannot process your request',
              msg: res.message,
              type: 'danger',
              duration: 7000
            });

            this.router.navigate(['/login']);
          }
          else
            resolve(true);
          sessionStorage.setItem('resetData', JSON.stringify(res))
        },
        (err: HttpErrorResponse) => {
          if (err.status === 401)
            console.log(err);
        }
      );
    });
  }

  updatepassword(body: UpdatePasswordReq) {
    return new Promise(resolve => {
      const oldpass = this.enc.encryptPwd(body.password);
      let data = {
        forgot_token: body.forgot_token,
        ref: body.ref,
        password: this.enc.encrypt(body.password, true),
        passwordenc: this.enc.encryptPwd(body.password),

      };
      this.http.post<UpdatePasswordRes>('updatepassword', data).subscribe(
        (res:any) => {
          var resp = res['data'].Status;

          if (resp == "Failed" || resp == undefined) {
            console.log( res['data'].message)
            sessionStorage.setItem('message', res['data'].error!= undefined||null? res['data'].error[0]:res['data'].message);
            resolve(false);
          } else {
            resolve(true);
            this.alert.open({
              heading: 'Password updated successfully',
              msg: `Your assword has been updated successfully`,
              type: 'success',
              duration: 5000
            });
          }
        },
        (err: HttpErrorResponse) => {
          if (err.status === 401)
            console.log(err);
          if (err.status === 400) {
            resolve(false);
            sessionStorage.setItem('message', err.error.data.error[0]);
          }
        }
      );
    });
  }

  forgotPassowrd(body: ForgotPasswordReq) {
    //debugger;
    return new Promise(resolve => {
      let data = {
        username: body.email
      };
      this.http.post<ForgotPasswordRes>('forgotpassword', data).subscribe(
        (res:any) => {
          if (res.Status == 'Failed') {
            sessionStorage.setItem('message', res.message);
            resolve(false);
          }
          else
            resolve(true);
          sessionStorage.setItem('message', res.message);
        },
        (err: HttpErrorResponse) => {
          if (err.status === 401) {
            console.log(err);
          }
          if (err.status === 400) {
            this.alert.open({
              heading: 'Sorry, Password update Failure',
              msg: 'System cannot process your request',
              type: 'danger',
              duration: 5000
            });
          }

        }
      );
    });
  }

  getUser() {
    return this.http.post<resetPwdUserInfo>('profile', { userid: this.loginData.UserId }).pipe(map((res:any) => res["data"]["records"]));
  }

  recaptchaApi(data: any) {
    return this.http.post<RecaptchaRes>('verifyrecaptcha', data).pipe(map((res:any) => res["data"]));
  }

  /** get the default URL based on role */
  get defaultUrl(): string {
    if (this._defaultUrls) {
      return this._defaultUrls;
    }
    if (!this.loginData?.DefaultPage) {
      return this._defaultUrls = null;
    }
    //this.navListData.forEach(a => {
    let isDefaultPage = false;
    this.AcessMenuList.newAccessMenu.forEach(a => {
      a.child.forEach(b => {
        if (b.id == this.loginData?.DefaultPage) {
          isDefaultPage = true;
          this._defaultUrls = `/${a.url}/${b.url}`;
        }
      });
    });
    if (!isDefaultPage)
      this._defaultUrls = null;

    return this._defaultUrls;
  }

  /** get the stored login data */
  set loginData(data: LoginRecords) {
    const dat: any = data;
    sessionStorage.setItem('token', dat);
  }

  /** Get logged in user details */
  get loginData() {
    this.userData = this.jwtHelper.decodeToken() as LoginRecords;
    return this.userData;
  }

  set AcessMenuList(data: AccessMenu) {
    const menu: any = data;
    sessionStorage.setItem('accessMenuJson', menu);
  }
  get AcessMenuList() {
    this.menuListData = this.jwtHelper.decodeToken(this.accessMenuJson) as AccessMenu;
    return this.menuListData;
  }

  get getBrowser() {
    const ua = navigator.userAgent;
    let tem;
    let M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null)
        return tem
          .slice(1)
          .join(' ')
          .replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
  }

  /** Logout the user and redirect to login */
  logout(): void {
    this.userData = null;
    this.menuListData = null;
    this._defaultUrls = null;
    this._navListLite = null;
    this._navMenuLists = null;
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  /** Check Role permission based on the AccessMenus */
  checkRolePermission(permission: string, url?: string): boolean {
    const navLite: any = this.navLite._navListLite;
    const navAccessMenus: any = this.navLite._accessMenus;

    const urlArray = !permission ? url.split('/') : this.router.url.split('/');
    urlArray.splice(0, 1);
    // const roles: any = this.loginData.AccessMenus || {};
    const roles: any = navAccessMenus || {};

    if (this.whiteListRoutes.includes(url)) return true;

    if ('accessDenied' === urlArray[0]) {
      console.log(urlArray[0])
      return true;
    }

    const firstID = navLite ? navLite[urlArray[0]].id : [];

    if (!roles[firstID]) {
      !permission && this.router.navigate(['/accessDenied']);
      return false;
    }
    if (urlArray.length > 1) {
      const secondID = navLite[urlArray[1]] ? navLite[urlArray[1]].id : '';
      const perms = navLite[urlArray[1]] ? navLite[urlArray[1]].perms : '';

      if (urlArray.length > 2 || permission) {
        const permString = permission || 'view';
        const permID = perms[permString];
        if (roles[secondID].includes(permID)) {
          return true;
        } else {
          !permission && this.router.navigate(['/accessDenied']);
          return false;
        }
      }
      if (roles[secondID]) {
        return true;
      }
    } else {
      return true;
    }
    // Navigate to the accessDenied page
    this.router.navigate(['/accessDenied']);
    return false;


  }

  // checkRolePermission(permission: string, url?: string): boolean {
  //   const newList = this.navLites();
  //   const navLite = this.navLite;
  //   const urlArray = !permission ? url.split('/') : this.router.url.split('/');
  //   urlArray.splice(0, 1);
  //   const roles: any = this.loginData.AccessMenus || {};

  //   if ('accessDenied' === urlArray[0]) {
  //     return true;
  //   }

  //   const firstID = navLite[urlArray[0]].id;

  //   if (!roles[firstID]) {
  //     !permission && this.router.navigate(['/accessDenied']);
  //     return false;
  //   }
  //   if (urlArray.length > 1) {
  //     debugger;
  //     const secondID = navLite[urlArray[1]] ? navLite[urlArray[1]].id : '';
  //     const perms = navLite[urlArray[1]] ? navLite[urlArray[1]].perms : '';

  //     if (urlArray.length > 2 || permission) {
  //       const permString = permission || 'view';
  //       const permID = perms[permString];
  //       if (roles[secondID].includes(permID)) {
  //         return true;
  //       } else {
  //         !permission && this.router.navigate(['/accessDenied']);
  //         return false;
  //       }
  //     }
  //     if (roles[secondID]) {
  //       return true;
  //     }
  //   } else {
  //     return true;
  //   }
  //   // Navigate to the accessDenied page
  //   this.router.navigate(['/accessDenied']);
  //   return false;
  // }
  submitError = false;
  //previousPageURL = '';
  handleUnauthorized(error: HttpErrorResponse, pop?) {
    /* console.log("error==");
    console.log(error); */
    const obj: ConfirmationDialog = {
      heading: 'Oops!',
      body: 'Unfortunately we encountered an error, if you wish to send the error details for us to investigate, please press "Ok" else "Cancel"',
      yesButton: 'Ok',
      noButton: 'Cancel'
    };
    // this.confirmationService.confirm(obj).then(isConfirmed => {
    //   if (!isConfirmed) {
    //     console.log("test");
    //   }}); 
    console.log(JSON.stringify(error));

    if (error.status === 401) {
      /*if(this.router.url==='/archive'){
        this.router.navigate(['/archive']);
        return;
      }
      else */
      if (this.router.url !== '/login') {
        this.alert.open({
          heading: 'Login Token Expired',
          msg: `Login token expired. Please login again`,
          type: 'danger',
          duration: this.errorMessageDuration
        });
        this.router.navigate(['/login']);
      } else {
        if (error.error && error.error.error && error.error.error === 'invalid_credentials') {
          this.alert.open({
            heading: 'Sorry, Login Attempt Failure',
            msg: `Invalid username or password`,
            type: 'danger',
            duration: 10000
          });
        }

      }

    } else {
      if (!(error.url && error.url.split("/").includes('exceptionlog'))) {
        //if(this.previousPageURL && this.previousPageURL !== this.router.url) {}
        pop.confirm(obj).then(isConfirmed => {
          this.http.post('exceptionlog', JSON.stringify(error)).subscribe(
            res => {
              console.log('res');
              console.log(res);
            },
            (err: HttpErrorResponse) => {
              if (err.status === 401) {
                console.log(err);
              }
            }
          );
          this.submitError = isConfirmed;
          if (isConfirmed) {
            console.log(" Submit the error to server. User Ok ");
          } else {
            console.log(" Submit the error to server not required. User Cancel ")
          }
        });

      } else {
        if (this.submitError) {
          this.alert.open({
            heading: 'Error',
            msg: `Please contact administrator.`,
            type: 'danger',
            duration: this.errorMessageDuration
          });
        }
      }
      // if (this.development === true) {
      //   const msg = error.error.message && error.error.message.split('(SQL')[0];
      //   this.alert.open({
      //     heading: 'Http Error Occured',
      //     msg: `status Code: ${error.status}
      // 		  message: ${msg}`,
      //     type: 'danger',
      //     duration: 10000
      //   });
      // }
    }

    // if (error.status !== 400) {
    //   const msg = error.error.message && error.error.message.split('(SQL')[0];
    //   this.alert.open({
    //     heading: 'Http Error Occurs',
    //     msg: `status Code: ${error.status}
    //           message: ${msg}`,
    //     type: 'danger',
    //     duration: 10000
    //   });
    // }
  }

  refreshToken() {
    // console.log(" refresh token in check inside start auth.service.ts :: ", new Date());
    if (this.refreshTokenTimeout) {
      // console.log(" refresh token in check inside start auth.service.ts :: inside if :: " + this.refreshTokenTimeout + " :: ", new Date());
      const tokenDate = this.jwtHelper.getTokenExpirationDate();
      const remainingSecounds = this.date.timeDifference(tokenDate);
      // console.log("remainingSecounds for token expiry :: ", remainingSecounds);
      if (remainingSecounds < 300) {
        // console.log(" refresh token in check inside start auth.service.ts :: inside if lessthan 300s :: " + remainingSecounds + " :: ", new Date());
        this.refreshTokenTimeout = false;
        this.http.post<LoginRes>('refreshtoken', null).subscribe((res:any) => {
          this.loginData = res.token;
          this.refreshTokenTimeout = true;
        });
      }
    }
  }

  get navListData(): NavList[] {
    const associatedId = btoa(this.loginData.AssociatedId);

    return [
      {
        title: 'Master',
        url: 'master',
        id: 1,
        child: [
          {
            title: 'Customer',
            id: 3,
            url: 'customer',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              }
            ]
          },
          {
            title: 'Equipment',
            id: 16,
            url: 'equipment',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              }
            ]
          },
          {
            title: 'Equipment Type',
            id: 7,
            url: 'equipmentType',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              }
            ]
          },
          {
            title: 'Haulier',
            id: 5,
            url: 'haulier',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              }
            ]
          },
          {
            title: 'Licence Master',
            id: 62,
            url: 'licenceMaster',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              }
            ]
          },
          {
            title: 'Load Content',
            id: 32,
            url: 'loadContent',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              }
            ]
          },
          {
            title: 'Location',
            id: 6,
            url: 'location',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              }
            ]
          },
          {
            title: 'Manufacturer',
            id: 4,
            url: 'manufacturer',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              }
            ]
          },
          {
            title: 'Package Rate',
            id: 18,
            url: 'packageRate',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 1002]
              }
            ]
          },
          {
            title: 'Quotation Authorisation Limit',
            id: 69,
            url: 'quotationAuthorisationLimit',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Transport Equipments',
            id: 124,
            url: 'transportEquipments',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'User',
            id: 11,
            url: 'user',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'User Role',
            id: 12,
            url: 'userRole',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Waste Loading Plan',
            id: 57,
            url: 'wasteLoadingPlan',
            freeze: [
              UserRoles.Admin,
              UserRoles.SuperAdmin,
              UserRoles.TypeBCustomer,
              UserRoles.Hauiler,
              UserRoles.Customer
            ],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.TypeBCustomer,
                  UserRoles.Customer,
                  UserRoles.Hauiler
                ]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.TypeBCustomer,
                  UserRoles.Customer
                ]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.TypeBCustomer
                  // UserRoles.Customer
                ]
              },
              {
                id: 4,
                name: 'afterInitial',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Email Logs',
            id: 3007,
            url: 'emailLogs',
            onlyToFreeze: true,
            freeze: [UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                onlyToFreeze: true,
                freeze: [UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Templates Master',
            id: 3002,
            url: 'templatesMaster',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          }
          // ,
          // {
          //   title: 'Archived List',
          //   id: 3005,
          //   url: 'archivedList',
          //   freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
          //   perms: [
          //     {
          //       id: 1,
          //       name: 'view',
          //       freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
          //     },
          //     {
          //       id: 2,
          //       name: 'add&Edit',
          //       freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
          //     },
          //     {
          //       id: 3,
          //       name: 'delete',
          //       freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
          //     }
          //   ]
          // }
        ]
      },
      {
        title: 'Calendar',
        url: 'calendar',
        id: 76,
        child: [
          // {
          //   title: 'Inspection Calendar',
          //   id: 73,
          //   url: 'inspectionCalendar',
          //   perms: [{             add: 1,             edit: 2,             delete: 3           }]
          // },
          // {
          //   title: 'Maintenance Calendar',
          //   id: 15,
          //   url: 'maintenanceCalendar',
          //   perms: [{             add: 1,             edit: 2,             delete: 3           }]
          // },
          {
            title: 'Transport Calendar',
            id: 42,
            url: 'transportCalendar',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 3],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 4,
                name: 'transMoves',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 3]
              },
              {
                id: 5,
                name: 'siteMoves',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          }
        ]
      },
      {
        title: 'Transaction',
        url: 'transaction',
        id: 2,
        child: [
          {
            title: 'Enquiry',
            id: 28,
            url: 'enquiry',
            freeze: [
              UserRoles.Admin,
              UserRoles.SuperAdmin,
              UserRoles.Customer,
              UserRoles.TypeBCustomer
            ],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.Customer,
                  UserRoles.TypeBCustomer
                ]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.Customer,
                  UserRoles.TypeBCustomer
                ]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.Customer,
                  UserRoles.TypeBCustomer
                ]
              },
              {
                id: 4,
                name: 'typeBPackagingSpares',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.TypeBCustomer
                ]
              },
              {
                id: 5,
                name: 'afterInitialEditable',
                freeze: [UserRoles.SuperAdmin]
              },
              {
                id: 6,
                name: 'afterAcknowledgedEditable',
                freeze: [UserRoles.SuperAdmin],
                onlyToFreeze: true
              }
            ]
          },
          {
            title: 'Logistics Service Quotation',
            id: 37,
            url: 'lsq',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Logistics Service Quotation - Acceptance',
            id: 38,
            url: 'lsqAcceptance',
            freeze: [
              UserRoles.Admin,
              UserRoles.SuperAdmin,
              UserRoles.Customer,
              UserRoles.TypeBCustomer
            ],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.Customer,
                  UserRoles.TypeBCustomer
                ]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.Customer,
                  UserRoles.TypeBCustomer
                ]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Quotations Accepted',
            id: 39,
            url: 'quotationsAccepted',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, UserRoles.Customer],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Quotations Rejected',
            id: 40,
            url: 'quotationsRejected',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, 4],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Quotation Status',
            id: 36,
            url: 'quotationStatus',
            freeze: [3],
            perms: [
              { id: 1, name: 'view', freeze: [3] },
              { id: 2, name: 'add&Edit', freeze: [3] },
              { id: 3, name: 'delete', freeze: [3] }
            ]
          },
          {
            title: 'RFQ WhiteBoard',
            id: 22,
            url: 'rfq',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Enquiry Reverse Status',
            id: 3006,
            url: 'reverseStatus',
            freeze: [UserRoles.SuperAdmin],
            onlyToFreeze: true,
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.SuperAdmin],
                onlyToFreeze: true
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.SuperAdmin],
                onlyToFreeze: true
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.SuperAdmin],
                onlyToFreeze: true
              }
            ]
          },
          {
            title: 'Haulier RFQ Whiteboard',
            id: 29,
            url: 'hrfq',
            freeze: [UserRoles.Hauiler],
            perms: [
              { id: 1, name: 'view', freeze: [UserRoles.Hauiler] },
              { id: 2, name: 'add&Edit', freeze: [UserRoles.Hauiler] },
              { id: 3, name: 'delete', freeze: [] }
            ]
          },
          {
            title: 'Service Order Form',
            id: 72,
            url: 'serviceOrderForm',
            freeze: [
              UserRoles.Admin,
              UserRoles.SuperAdmin,
              UserRoles.Hauiler,
              UserRoles.Customer,
              UserRoles.TypeBCustomer
            ],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.Hauiler,
                  UserRoles.Customer,
                  UserRoles.TypeBCustomer
                ]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.Hauiler,
                  UserRoles.Customer,
                  UserRoles.TypeBCustomer
                ]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Audit Log',
            id: 3008,
            url: 'log',
            freeze: [UserRoles.SuperAdmin],
            onlyToFreeze: true,
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.SuperAdmin],
                onlyToFreeze: true
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.SuperAdmin],
                onlyToFreeze: true
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.SuperAdmin],
                onlyToFreeze: true
              }
            ]
          }
        ]
      },
      {
        title: 'Inventory',
        url: 'inventory',
        id: 10,
        child: [
          {
            title: 'Equipment Order',
            id: 49,
            url: 'equipmentOrder',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Equipment Status Update',
            id: 50,
            url: 'equipmentStatusUpdate',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Forecast',
            id: 44,
            url: 'forecast',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          }
        ]
      },
      {
        title: 'Transport',
        url: 'transport',
        id: 77,
        child: [
          // {
          //   title: 'Debrief WB',
          //   id: 41,
          //   url: 'debriefWB',
          //   freeze: [UserRoles.Admin, UserRoles.SuperAdmin, UserRoles.Hauiler],
          //   perms: [
          //     {
          //       id: 1,
          //       name: 'view',
          //       freeze: [
          //         UserRoles.Admin,
          //         UserRoles.SuperAdmin,
          //         UserRoles.Hauiler
          //       ]
          //     },
          //     {
          //       id: 2,
          //       name: 'add&Edit',
          //       freeze: [
          //         UserRoles.Admin,
          //         UserRoles.SuperAdmin,
          //         UserRoles.Hauiler
          //       ]
          //     },
          //     {
          //       id: 3,
          //       name: 'delete',
          //       freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
          //     }
          //   ]
          // },
          {
            title: 'Performance Pack YTD KPI(s)',
            id: 82,
            url: 'performancePackYtd',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Transport Jobs',
            id: 68,
            url: 'transportJobs',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin, UserRoles.Hauiler],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.Hauiler
                ]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [
                  UserRoles.Admin,
                  UserRoles.SuperAdmin,
                  UserRoles.Hauiler
                ]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          }
        ]
      },
      {
        title: 'Packaging',
        url: 'packaging',
        id: 78,
        child: [
          {
            title: '3 x Reuse',
            id: 63,
            url: '3xReuse',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'ACEP Process',
            id: 65,
            url: 'acepProcess',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Block Container',
            id: 125,
            url: 'blockContainer',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Device Tracker Mapping',
            id: 51,
            url: 'deviceTrackerMapping',
            freeze: [],
            active: false,
            perms: [
              { id: 1, name: 'view', freeze: [] },
              { id: 2, name: 'add&Edit', freeze: [] },
              { id: 3, name: 'delete', freeze: [] }
            ]
          },
          {
            title: 'Equipment Release Request',
            id: 79,
            url: 'equipmentReleaseRequest',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Equipment Tracking',
            id: 52,
            url: 'equipmentTracking',
            freeze: [],
            active: false,
            perms: [
              { id: 1, name: 'view', freeze: [] },
              { id: 2, name: 'add&Edit', freeze: [] },
              { id: 3, name: 'delete', freeze: [] }
            ]
          },
          /*       {
            title: 'Inspection Request',
            id: 71,
            url: 'inspectionRequest',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          }, */
          {
            title: 'Maintenance Update',
            id: 66,
            url: 'maintenanceUpdate',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Packaging Dashboard',
            id: 86,
            url: 'packagingDashboard',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Packaging RFQ WhiteBoard',
            id: 67,
            url: 'prfq',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Release rental containers',
            id: 129,
            url: 'releaseRentalContainers',
            freeze: [],
            active: false,
            perms: [
              { id: 1, name: 'view', freeze: [] },
              { id: 2, name: 'add&Edit', freeze: [] },
              { id: 3, name: 'delete', freeze: [] }
            ]
          },
          {
            title: 'Equipment Release Update',
            id: 80,
            url: 'equipmentReleaseUpdate',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Manufacture Update',
            id: 74,
            url: 'manufactureUpdate',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          }
        ]
      },
      {
        title: 'Packaging Reports',
        url: 'packagingReport',
        id: 113,
        child: [
          {
            title: '3 x Re-use Containers',
            id: 105,
            url: 'reuseContainers',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Acep Containers',
            id: 104,
            url: 'acepContainers',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Acep Report',
            id: 122,
            url: 'acepReport',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Container Licence Expiry',
            id: 88,
            url: 'containerLicenceExpiry',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'CSC Expiry Report',
            id: 93,
            url: 'cscExpiry',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          // {
          //   title: 'Equipment Release Request',
          //   id: 79,
          //   url: 'equipmentReleaseRequest',
          //   perms: [{             add: 1,             edit: 2,             delete: 3           }]
          // },
          {
            title: 'Customer Acep Summary',
            id: 106,
            url: 'customerAcepSummary',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Customer Enquiry Report',
            id: 107,
            url: 'customerEnquiryReport',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Customers and Containers',
            id: 87,
            url: 'customerContainer',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Equipment and Equipment Order',
            id: 120,
            url: 'equipmentAndEquipmentOrder',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Equipment Usage Details',
            id: 119,
            url: 'equipmentUsageDetails',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Finance Report',
            id: 83,
            url: 'financeReport',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Inspection Time',
            id: 108,
            url: 'inspectionTime',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'List of Containers',
            id: 92,
            url: 'listOfContainers',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Travel Time',
            id: 109,
            url: 'travelTime',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'WLP Elapsed',
            id: 99,
            url: 'wlpElapsed',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'WLP Expiry Report',
            id: 102,
            url: 'wlpExpiryReport',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'WLP Live',
            id: 90,
            url: 'wlpLive',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'WLP Rejected',
            id: 96,
            url: 'wlpRejected',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'WLP Withdrawn',
            id: 101,
            url: 'wlpWithdrawn',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          }
        ]
      },
      {
        title: 'Transport Reports',
        url: 'transportReport',
        id: 84,
        freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
        child: [
          {
            title: 'Enquiry Turnaround Time',
            id: 126,
            url: 'enquiryTurnaroundTime',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Haulier RFQ Report',
            id: 127,
            url: 'haulierRfqReport',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Incomplete Enquiry Report',
            id: 128,
            url: 'incompleteEnquiryReport',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          /*
          {
            title: 'Mileage Report',
            id: 112,
            url: 'mileageReport',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Site Performance Report',
            id: 110,
            url: 'sitePerformanceReport',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Transport Performance Report',
            id: 111,
            url: 'transportPerformanceReport',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Weekly Debrief KPI',
            id: 114,
            url: 'weeklyDebrief',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          */
          {
            title: 'Forum',
            id: 3004,
            url: `${this.hostName}/llwrForum/public/auth/${associatedId}`,
            externalUrl: true,
            isNewPage: true,
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          }
        ]
      },
      {
        title: 'Manufacturer Reports',
        url: 'manufacturerReport',
        id: 115,
        child: [
          {
            title: 'Container Ageing',
            id: 116,
            url: 'containerAgeing',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          },
          {
            title: 'Manufactured Containers with 0191',
            id: 117,
            url: 'manufacturedContainers',
            freeze: [UserRoles.Admin, UserRoles.SuperAdmin],
            perms: [
              {
                id: 1,
                name: 'view',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 2,
                name: 'add&Edit',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              },
              {
                id: 3,
                name: 'delete',
                freeze: [UserRoles.Admin, UserRoles.SuperAdmin]
              }
            ]
          }
        ]
      }
    ];
  }

}
